import { FC } from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import Image from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import { ContentCardProps } from './types';

const ContentCard: FC<ContentCardProps> = ({ title, description, image, ctaReference, ctaLabel }) => {
  return (
    <div className="flex flex-col">
      <div className="mb-16 overflow-hidden">
        <Image {...image} className="w-full object-cover md:max-h-[340px] md:min-h-[400px]" />
      </div>
      <Typography className="body-text-large mb-4 font-medium" as="h4">
        {title}
      </Typography>
      <Typography className="body-text" as="p">
        {description}
      </Typography>

      {ctaReference && ctaLabel && (
        <Link link={ctaReference} className="hyperlink mt-16 font-bold text-blue underline underline-offset-2">
          {ctaLabel}
        </Link>
      )}
    </div>
  );
};

export default ContentCard;
